import Router from '../router'
import { useToast } from 'vue-toast-notification'
import { Modal } from 'bootstrap';

import { useKeycloak, getToken } from '@josempgon/vue-keycloak'


export const showAccountDetails = function () {
  Router.push({ name: 'account-detail' })
}

export const showProductDetails = function () {
  Router.push({ name: 'product-detail' })
}

export const showCardDetails = function () {
  Router.push({ name: 'card-detail' })
}

export const showOrderDetails = function () {
  Router.push({ name: 'order-detail' })
}

export const showBeneficiaryDetails = function () {
  Router.push({ name: 'beneficiaryservice-detail' })
}

export const showOperationDetails = function () {
  Router.push({ name: 'operation-detail' })
}

export const getHeaders = async function () {
  const token = await getToken();
  const username = useKeycloak().decodedToken.value.family_name ? useKeycloak().decodedToken.value.family_name : ''
  return {
    id: username,
    authorization: 'Bearer ' + (token ? token : '')
  }
}
export const exportProduct = (product, productStructure, i18n) => {
  let jsonProduct = {}
  jsonProduct['parent'] = null
  for (var i in productStructure) {
    jsonProduct[productStructure[i].fieldName] = {}
    for (var j in productStructure[i].params) {
      jsonProduct[productStructure[i].fieldName][productStructure[i].params[j].fieldName] = product[productStructure[i].fieldName][productStructure[i].params[j].fieldName]
    }
  }
  jsonProduct['status'] = 'ACTIVE'
  // Convert the JSON array to a string
  const jsonString = JSON.stringify(jsonProduct);

  // Copy the string to the clipboard
  if (!navigator.clipboard) {
    let copyModal = new Modal(document.getElementById('copyModal'))
    copyModal.show()
    document.getElementById('copyModalText').innerHTML = jsonString
  }
  else {
    navigator.clipboard.writeText(jsonString)
    .then(() => {
      const $toast = useToast()
      $toast.open({
        message: i18n.t('label.product.productCopied'),
        type:'default',
        position: 'bottom',
        duration: 5000,
        dismissible:true
      });
    })
    .catch(err => {
        console.error('Failed to copy JSON array: ', err);
    });
  }
}

// Method to get the date of today + 2 days
// Used to set the minimum date for the date picker
// Minimum consideration date to create a new product
export const getPlus1Date = () => {
  let todayDate = new Date()

  let plus1Date = new Date(todayDate);

  // Add 1 day to the current date
  plus1Date.setDate(todayDate.getDate() + 1);

  // Get the adjusted year, month, and day
  let year = plus1Date.getFullYear();
  let month = (plus1Date.getMonth() + 1).toString(); // Months are 0-indexed, so we add 1
  let day = plus1Date.getDate();

  // Format month and day to ensure two digits
  if (month.length < 2) {
    month = '0' + month;
  }
  if (day < 10) {
      day = '0' + day;
  }
  return year + '-' + month + '-' + day
}
